import {
  CertificateStatusEnum,
  isInstalmentWalletPaymentType,
  type IInstalmentSchedule,
  type IUserCertificate,
} from '@share/common-types';

export function instalmentScheduleHasFailedPayment(
  instalmentSchedule: IInstalmentSchedule | undefined,
): boolean {
  return (
    instalmentSchedule?.instalments.some((instalment) => instalment.status === 'failed') ?? false
  );
}

export function certificateHasFailedInstalmentPayment(certificate: IUserCertificate): boolean {
  if (certificate.status !== CertificateStatusEnum.Pending) {
    return false;
  }
  if (!isInstalmentWalletPaymentType(certificate.paymentType)) {
    return false;
  }
  return instalmentScheduleHasFailedPayment(certificate.instalmentSchedule);
}
